<template>
  <div id="grid"></div>
</template>

<script>
import $$vm from "@/data/index";
export default {
  name: "Test",
  mounted() {
    $(document).ready(function () {
      var aaaa = $("#grid").kendoGrid({
        dataSource: {
          // type: (function() { if (kendo.data.transports['aspnetmvc-ajax']) { return 'aspnetmvc-ajax'; } else { throw new Error('The kendo.aspnetmvc.min.js script is not included.'); } })(),
          transport: {
            read: function (options) {
              if ($$vm.cn) {
                // options.data.sorts = this.sort();
                // options.data.filters = this.filter();
                // options.data.groups = this.filter();
                console.log(options.data);
                var req = $$vm.compress1(JSON.stringify(options.data));
                $$vm.c.invoke("knacc", req).then(
                  function (data) {
                    var res = $$vm.decompress(data);
                    console.log(res);
                    //options.success([]);
                  },
                  function (err) {
                    console.log(err);
                  }
                );
              }
            },
          },
          schema: {
            model: {
              fields: {
                Dt: { type: "date" },
                Id: {type: "number"},
                Amt: {type: "number"},
                Com: {type: "number"},
                R: {type: "string"}
              },
            },
          },
          pageSize: 20,
          groupable: true,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          sort:{
            field: "Dt",
            dir: "desc"
          }
        },
        height: 550,
        pageable: { info: true, refresh: true, pageSizes: [10, 15, 20, 25], buttonCount: 5, previousNext: true },
        toolbar: ["excel", "pdf", "search"],
        search: {
          fields: [
            { name: "R", operator: "contains" },
          ],
        },
        excel: {
          fileName: "users.xlsx",
          proxyURL: "https://demos.telerik.com/kendo-ui/service/export",
          filterable: true,
        },
        pdf: {
          allPages: true,
          avoidLinks: true,
          paperSize: "A4",
          margin: { top: "2cm", left: "1cm", right: "1cm", bottom: "1cm" },
          landscape: true,
          repeatHeaders: true,
          template: $("#page-template").html(),
          scale: 0.8,
        },
        pdfExport: function (e) {
          e.sender.wrapperClone.addClass("k-clone");
        },
        filterable: true,
        sortable: {
          mode: "mixed",
          allowUnsort: true,
          showIndexes: true,
        },
        pageable: {
          buttonCount: 5
        },
        columnMenu: true,
        mobile: $$vm.ismobile,
        resizable: true,
        columns: [
          { title: "When", width: "200px", template: "#=kendo.toString(Dt,\u0027yyyy-MM-dd HH:mm:ss fff\u0027)#", field: "Dt", filterable: { ui: $$vm.datepicker }, encoded: true, sortable: { "initalDirection": "desc" } },
          { title: "Sr No", width: "200px", field: "Id", filterable: false, encoded: true },
          { title: "Amt", width: "200px", template: "\u003cspan style=\u0027float:right;\u0027\u003e#= kendo.toString(Amt, \u0027n2\u0027)#\u003c/span\u003e", field: "Amt", filterable: { messages: { selectedItemsFormat: "{0} selected items" }, checkAll: false }, encoded: true, groupable: false, filterable: false },
          { title: "Com", width: "200px", template: "\u003cspan style=\u0027float:right;\u0027\u003e#= kendo.toString(Com, \u0027n2\u0027)#\u003c/span\u003e", field: "Com", filterable: { messages: { selectedItemsFormat: "{0} selected items" }, checkAll: false }, encoded: true, groupable: false, filterable: false },
          {
            field: "R",
            title: "Remarks",
            width: "1000px",
            filterable: true
          },
        ],
      }).data("kendoGrid");
      if ($$vm.ismobile) {
        $("#grid").data("kendoGrid").resize();
      }
      console.log(aaaa);
    });
  },
};
</script>

<style></style>
